export const AUTH_STORAGE_KEYS = {
  token: "authToken",
  email: "userEmail",
} as const;

export const auth = {
  setSession: (token: string, email: string) => {
    if (!token) return;
    localStorage.setItem(AUTH_STORAGE_KEYS.token, token);
    localStorage.setItem(AUTH_STORAGE_KEYS.email, email);
  },

  clearSession: () => {
    localStorage.removeItem(AUTH_STORAGE_KEYS.token);
    localStorage.removeItem(AUTH_STORAGE_KEYS.email);
  },

  getToken: () => {
    const token = localStorage.getItem(AUTH_STORAGE_KEYS.token);
    return token || null;
  },
  
  getEmail: () => localStorage.getItem(AUTH_STORAGE_KEYS.email),

  isAuthenticated: () => !!localStorage.getItem(AUTH_STORAGE_KEYS.token),
}; 